import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { utilTick } from "../../../utils/utilTick";
import { actionPlayerInfoRemoveBuffs, TypeActionPlayerInfo, } from "./actionPlayerInfo";
export var epicPlayerInfoOnBuffExpire = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.ExpiredBuff), switchMap(function (action) {
        var buff = action.buff, remainingTime = action.remainingTime;
        return utilTick.getInterval$(remainingTime * 1000).pipe(switchMap(function () {
            return of(actionPlayerInfoRemoveBuffs(buff));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player/epicPlayerInfoOnBuffExpire.ts
// module id = 1931
// module chunks = 3